import { isNumber } from '@grandvisionhq/utils';

const getFramesDisplayPrice = (variantPrice, offeringPrice, sspTotalPrice)=>{
    const { currency , originalPrice: originalVariantPrice , discountedPrice: discountedVariantPrice ,  } = variantPrice;
    if (isNumber(sspTotalPrice)) {
        const nonFrameSSPPrice = sspTotalPrice - originalVariantPrice;
        return {
            originalPrice: sspTotalPrice,
            /**
       * When the product doesn't have a discounted price, we want to keep it that way.
       * If the (total) discounted price returned from here is a number (even 0), it will
       * show up on the PDP. So we want to keep it undefined.
       */ discountedPrice: discountedVariantPrice ? discountedVariantPrice + nonFrameSSPPrice : undefined,
            currency
        };
    }
    /**
   *
   * The offering price is added on top of the variant price
   *
   * -- No discounts --
   * originalVariantPrice: €10
   * offeringOriginalPrice: +€3
   *
   * Displayed total price:  10 + 3 = €13
   *
   *
   *  -- Only Offering with discount --
   * originalVariantPrice: €10
   * offeringOriginalPrice: +€3
   * offeringDiscountPrice: +€1
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:    10 + 1 = €11
   *
   *
   * -- Only Variant with discount --
   * originalVariantPrice: €10
   * discountedVariantPrice: €9
   * offeringOriginalPrice: +€3
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:     9 + 3 = €12
   *
   *
   * -- Variant AND Offering with discount --
   * originalVariantPrice: €10
   * discountedVariantPrice: €9
   * offeringOriginalPrice: +€3
   * offeringDiscountPrice: +€1
   *
   * Displayed total pre-discount price:  10 + 3 = €13
   * Displayed total discounted price:     9 + 1 = €10
   *
   */ if (offeringPrice) {
        const { value: offeringOriginalPrice , discounted: offeringDiscount  } = offeringPrice;
        const offeringOriginalPriceValue = offeringOriginalPrice.centAmount;
        const displayedOriginalPrice = originalVariantPrice + offeringOriginalPriceValue;
        let displayedDiscountPrice = discountedVariantPrice;
        if (offeringDiscount) {
            const offeringDiscountPrice = offeringDiscount.value.centAmount;
            displayedDiscountPrice = discountedVariantPrice ? discountedVariantPrice + offeringDiscountPrice : originalVariantPrice + offeringDiscountPrice;
        } else {
            displayedDiscountPrice = displayedDiscountPrice ? displayedDiscountPrice + offeringOriginalPriceValue : displayedDiscountPrice;
        }
        return {
            originalPrice: displayedOriginalPrice,
            discountedPrice: displayedDiscountPrice,
            currency
        };
    }
    return variantPrice;
};

export { getFramesDisplayPrice };
//# sourceMappingURL=get-frames-display-price.js.map
